<b-modal v-model="modal_special_requirement_ES9" :size="modalSize" :header-bg-variant="headerColor"
  header-text-variant="light" no-close-on-backdrop no-close-on-esc centered no-stacking>
  <!-- ヘッダー -->
  <template v-slot:header>
    <div class="text-center w-100">
      {{ headerTitle }}
    </div>
  </template>

  <!-- 文言表示 -->
  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid" style="min-height: 140px;">
        <!-- 一覧表示 -->
        <template v-if="phase === 'listView'">
          <custom-table useStripeStyle hasTabs :items="wallDisplayInfo" :columns="tableColumns" useSort
            currentSortkey="status" initSortDir="asc" class="mt-2 ml-2" type="simple" usePopup rowSelect
            @rowButtonClicked="rowButtonClickEvent">
            <template v-slot:rowButton>{{ $t(`individual.button_fd`) }}</template>
          </custom-table>
        </template>
        <!-- 履歴データなし表示 -->
        <template v-if="phase === 'nodata'">
          {{ $t(`individual.label_history`) }}
        </template>
        <!-- 詳細FD表示 -->
        <template v-if="phase === 'detailedFd'">
          <div class="row ml-1">
            <div class="ml-2">
              <label>{{ statusLabel }}</label>
            </div>
            <div class="ml-2">
              <label class="statusValue">{{ statusValue }}</label>
            </div>
          </div>
          <b-button size="sm" variant="primary" :disabled="isLoading" @click="csvExport" class="mx-2">
            {{ $t('message.file_export') }}
          </b-button>
          <custom-table class="detailedFd mt-2 ml-2" useStripeStyle hasTabs :items="displayFdInfo"
            :columns="tableFdColumns" useSort currentSortkey="did" initSortDir="asc" type="simple" usePopup>
          </custom-table>
        </template>
        <!-- プロジェクトデータ保存 -->
        <template v-if="phase === 'projectData'">
          <project-data ref="projectData" :vin="vin" :vehicleName="vehicleName" :displayProjectID="displayProjectID"
            :registrationNumber="registrationNumber" :functionName="functionName" :dataName="dataName" :memo="memo"
            :hideRegistrationNumber="hideRegistrationNumber"></project-data>
        </template>
        <!-- 共通エラー -->
        <template v-if="phase === 'failed'">
          <div class="w-100">
            <div class="box-margin-right work-support-message">
              {{ $t(`individual.error_communication_error`) }}
            </div>
          </div>
        </template>
      </div>
    </b-overlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center ">
      <b-button v-if="showButtonCancel" size="sm" :disabled="isLoading" variant="outline-primary"
        @click="onCancelClicked" :class="cancelButtonClass">
        {{ $t('message.common_button_cancel') }}
      </b-button>
      <b-button v-if="showButtonSave" size="sm" :disabled="isDisabledSave"
        :variant="phase === 'nodata' ? 'Secondary' : 'primary'" @click="onSaveClicked" :class="saveButtonClass">
        {{ $t('message.common_button_save') }}
      </b-button>
      <b-button v-if="showButtonBack" size="sm" :disabled="isLoading" variant="outline-primary" @click="onBackClicked"
        class="mx-2">
        {{ $t('message.common_button_back') }}
      </b-button>
      <b-button v-if="showButtonOk" size="sm" :disabled="isLoading" variant="primary" @click="onOkClicked" class="mx-2">
        {{ $t('message.common_button_ok') }}
      </b-button>

      <!-- 一覧表示 --><!-- 履歴データなし表示 -->
      <b-form-select v-if="(phase === 'listView' || phase === 'nodata') && controlHistoryTypeList.length > 0"
        class="custom-select custom-select-sm mx-2 mt-2" v-model="selectedId" @change="changeControlHistoryType"
        :disabled="isLoading">
        <option v-for="selectedItem in controlHistoryTypeList" :value="selectedItem.control_history_type_id">
          {{ selectedItem.control_history_type_name }}
        </option>
      </b-form-select>
    </div>
  </template>
</b-modal>